/**
 * What a user confirms before a data source may run. Twin of src/shared/connectorRights.js
 * (only the export line differs) so the logged text is exactly what was shown.
 */

// Bump when RIGHTS_POINTS change; everyone confirms again on their next save.
const RIGHTS_VERSION = '2026-10-31';

const RIGHTS_TITLE = 'I confirm on behalf of our company that:';

const RIGHTS_POINTS = [
  'We may use this platform and its API for this purpose: its terms of use, licence or subscription allow automated requests and using the results for our sales outreach.',
  'We have a legal basis under the GDPR (usually legitimate interest, Art. 6(1)(f)) to send the contact data listed above to this platform and to store its results on our contacts, and we meet our duties to inform those contacts (Art. 13/14 GDPR).',
  'Requests identify our company as the sender (company name and contact email below), as many platforms require.',
  'Where the platform processes personal data on our behalf, the required agreements are in place (e.g. a data processing agreement under Art. 28 GDPR and safeguards for transfers outside the EU).',
  'SalesGod only sends these requests on our instruction. We are responsible for choosing this data source and for how its data is used.',
];

const NEUTRAL_AGENT = 'DataConnector/1.0';
const EMAIL_RE = /^[^\s@<>()"]+@[^\s@<>()"]+\.[a-z]{2,}$/i;

/**
 * User-Agent naming the customer, not the platform: "Acme-GmbH-Research/1.0 (+mailto:info@acme.de)".
 * Platforms that block by sender then block this one customer.
 */
function requesterUserAgent({ company, email } = {}) {
  const name = String(company || '')
    .replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^A-Za-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40)
    .replace(/-+$/, '');
  const mail = EMAIL_RE.test(String(email || '').trim()) ? String(email).trim().slice(0, 120) : '';
  const product = name ? `${name}-Research/1.0` : NEUTRAL_AGENT;
  return mail ? `${product} (+mailto:${mail})` : product;
}

/** The exact text that gets logged, including where the data goes and how we sign requests. */
function rightsText({ host, inputLabels = [], sender = NEUTRAL_AGENT }) {
  return [
    RIGHTS_TITLE,
    ...RIGHTS_POINTS.map((p, i) => `${i + 1}. ${p}`),
    `Data sent per contact: ${inputLabels.length ? inputLabels.join(', ') : 'none'} → ${host}`,
    `Sender identification: ${sender}`,
  ].join('\n');
}

export { RIGHTS_VERSION, RIGHTS_TITLE, RIGHTS_POINTS, NEUTRAL_AGENT, requesterUserAgent, rightsText };
